export default class FormatHelper {
    static formatValueWithNoDecimals(value_to_format) {
        let parsedValue = parseFloat(value_to_format);

        return !isNaN(parsedValue) ? parsedValue.toFixed(0) : '';
    }
    static formatValueWithTwoDecimals(value_to_format) {
        let parsedValue = parseFloat(value_to_format);

        return !isNaN(parsedValue) ? parsedValue.toFixed(2) : '';
    }
}